import { ReactElement, useCallback } from "react";
import { IFormHandler } from "client/Forms";
import { localize } from "client_legacy/ndaw/culture";
import { Item } from "./NotificationSettingsDialog";
import { NotificationSection } from "./NotificationSection";

export type EmailSettingsState = {
	dailyBriefingEmail: Item;
	weeklyBriefingEmail: Item;
};

export type BriefingEmailSectionProps = {
	formHandler: IFormHandler<EmailSettingsState>;
};

export const BriefingEmailSection = (props: BriefingEmailSectionProps): ReactElement => {
	const { formHandler } = props;

	const changeHandler = useCallback(
		(
			isEnabled: boolean,
			property: StringKeyOf<EmailSettingsState>
		): void => {
			if (!isEnabled) {
				return;
			}

			if (property === "dailyBriefingEmail") {
				formHandler.for("weeklyBriefingEmail")
					.reducer
					.setValue({
						isEnabled: false
					});
				formHandler.for("weeklyBriefingEmail")
					.validation
					.triggerInputFinished();
			} else {
				formHandler.for("dailyBriefingEmail")
					.reducer
					.setValue({
						isEnabled: false
					});
				formHandler.for("dailyBriefingEmail")
					.validation
					.triggerInputFinished();
			}
		},
		[formHandler]
	);

	return (
		<NotificationSection
			title={localize("_Summary")}
			trackingId="briefing"
		>
			<NotificationSection.ItemList>
				<NotificationSection.Item
					label={localize("_DailySummaryOfWorkspaceActivities")}
					subtext={localize("_DailySummaryOfWorkspaceActivityDescription")}
					attachable={formHandler.for("dailyBriefingEmail")
						.for("isEnabled")
						.attachToCheckbox()
						.withOnChange(isEnabled => changeHandler(isEnabled, "dailyBriefingEmail"))
					}
				/>

				<NotificationSection.Item
					label={localize("_WeeklySummaryOfWorkspaceActivities")}
					subtext={localize("_WeeklySummaryOfWorkspaceActivityDescription")}
					attachable={formHandler.for("weeklyBriefingEmail")
						.for("isEnabled")
						.attachToCheckbox()
						.withOnChange(isEnabled => changeHandler(isEnabled, "weeklyBriefingEmail"))
					}
				/>
			</NotificationSection.ItemList>
		</NotificationSection>
	);
};

BriefingEmailSection.displayName = "BriefingEmailSection";
